import classNames from 'classnames'

import type { ReactElement } from 'react'

import Badge from '~/components/Badge'

import './styles.scss'

interface Props {
  isCurrentPageContainerSelected: boolean
  value: string
}

const NavigationTargetBadge = ({ isCurrentPageContainerSelected, value }: Props): ReactElement => {
  const badgeClasses = classNames('navigation-target-badge', { selected: isCurrentPageContainerSelected })

  return <Badge className={badgeClasses} outlined={!isCurrentPageContainerSelected} size="large" value={value} />
}

export default NavigationTargetBadge
